// extracted by mini-css-extract-plugin
module.exports = {"mall-landing-page":"style_mall-landing-page__ZP8M2","container":"style_container__HTehD"};